module.exports = __webpack_public_path__ + "img/lagos_02.5d306319.jpg";